import { decipherMappingFeature } from './decipher-mapping.reducer';

export const {
  selectDecipherMappingState,
  selectLocaleMappings,
  selectQualificationsByLocale,
  selectIsLoading,
  selectSavingLocale,
  selectError,
} = decipherMappingFeature;

export const selectDecipherLocaleMappings = selectLocaleMappings;
export const selectDecipherQualificationsByLocale =
  selectQualificationsByLocale;
export const selectIsDecipherLoading = selectIsLoading;
export const selectDecipherSavingLocale = selectSavingLocale;
